module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//vs.png?v=5cba5c45";